import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  SignUpCommand,
  ConfirmSignUpCommand,
  ForgotPasswordCommand,
  ConfirmForgotPasswordCommand,
} from "@aws-sdk/client-cognito-identity-provider";
const clientId = process.env.REACT_APP_CLIENT_ID;
const region = process.env.REACT_APP_REGION;

export const cognitoClient = new CognitoIdentityProviderClient({
  region: region,
});

export const signIn = async (username, password) => {
  const params = {
    AuthFlow: "USER_PASSWORD_AUTH",
    ClientId: clientId,
    AuthParameters: {
      USERNAME: username,
      PASSWORD: password,
    },
  };
  try {
    const command = new InitiateAuthCommand(params);
    const { AuthenticationResult } = await cognitoClient.send(command);
    if (AuthenticationResult) {
      localStorage.setItem("idToken", AuthenticationResult.IdToken || "");
      localStorage.setItem(
        "accessToken",
        AuthenticationResult.AccessToken || ""
      );
      localStorage.setItem(
        "refreshToken",
        AuthenticationResult.RefreshToken || ""
      );
      return AuthenticationResult;
    }
  } catch (error) {
    // console.error("Error signing in: ", error);
    throw error;
  }
};

export const signUp = async (email, password, firstName, lastName, phoneNo) => {
  const params = {
    ClientId: clientId,
    Username: email,
    Password: password,
    UserAttributes: [
      {
        Name: "email",
        Value: email,
      },

      {
        Name: "given_name",
        Value: firstName,
      },
      {
        Name: "family_name",
        Value: lastName,
      },
      {
        Name: "phone_number",
        Value: phoneNo,
      },{
        Name:"custom:notificationSetting",
        Value:"all"
      }
    ],
  };
  try {
    const command = new SignUpCommand(params);
    const response = await cognitoClient.send(command);
    // console.log("Sign up success: ", response);
    return response;
  } catch (error) {
    console.error("Error signing up: ", error);
    throw error;
  }
};

export const confirmSignUp = async (username, code) => {
  const params = {
    ClientId: clientId,
    Username: username,
    ConfirmationCode: code,
  };
  try {
    const command = new ConfirmSignUpCommand(params);
    await cognitoClient.send(command);
    // console.log("User confirmed successfully");
    return true;
  } catch (error) {
    console.error("Error confirming sign up: ", error);
    throw error;
  }
};

export const forgotPassword = async (username) => {
  const params = {
    ClientId: clientId,
    Username: username,
  };
  try {
    const command = new ForgotPasswordCommand(params);
    const response = await cognitoClient.send(command);
    // console.log("Password reset initiated: ", response);
    return response;
  } catch (error) {
    console.error("Error initiating password reset: ", error);
    throw error;
  }
};

export const confirmForgotPassword = async (username, code, newPassword) => {
  const params = {
    ClientId: clientId,
    Username: username,
    ConfirmationCode: code,
    Password: newPassword,
  };
  try {
    const command = new ConfirmForgotPasswordCommand(params);
    await cognitoClient.send(command);
    // console.log("Password reset confirmed");
    return true;
  } catch (error) {
    console.error("Error confirming password reset: ", error);
    throw error;
  }
};


export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  const params = {
    AuthFlow: "REFRESH_TOKEN_AUTH",
    ClientId: clientId,
    AuthParameters: {
      REFRESH_TOKEN: refreshToken,
    },
  };

  try {
    const command = new InitiateAuthCommand(params);
    const result = await cognitoClient.send(command);
    const { AuthenticationResult } = result;
    if (AuthenticationResult) {
      localStorage.setItem("idToken", AuthenticationResult.IdToken || "");
      localStorage.setItem("accessToken", AuthenticationResult.AccessToken || "");
      return AuthenticationResult;
    }
  } catch (error) {
    console.error("Error refreshing token: ", error);
    throw error;
  }
};